import React from "react";
import capitalize from "../../../Utils/capitalize";

const ItemBody25 = ({ notification }) => {
  const total = Number(notification?.metaData?.quantity || 0);

  return (
    <div className="min-h-20">
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium">{total} kWh energy</span> was added in{" "}
        <span className="font-medium">
          {capitalize(notification?.metaData?.driverFirstName || "driver")}’s
          wallet.
        </span>
      </p>
    </div>
  );
};

export default ItemBody25;
